import { render, staticRenderFns } from "./PermissionsListToolbar.vue?vue&type=template&id=91a98fe6&"
import script from "./PermissionsListToolbar.vue?vue&type=script&lang=js&"
export * from "./PermissionsListToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports